module.exports = __webpack_public_path__ + "static/media/previewlifestyle3-small.c13469a1.jpg";